import React from "react";
import classes from './SelectDropdown.css';
import Select from 'react-select';

const SelectDropdown = ({
    customHeight,
    customWidth = '150px',
    name,
    defaultValue,
    value,
    options,
    isSearchable,
    onChange,
    placeholder,
    id,
    key
  }) => {
    return (
        <Select
          key={key}
          id={id}
          className={name}
          classNamePrefix={name}
          defaultValue={defaultValue}
          name={name}
          options={options}
          isSearchable={isSearchable}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          styles={{
            control:(base) => ({
              ...base,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              minHeight: '30px',
              height: '30px',
              width: customWidth,
              padding: '0',

            }),
            menu:(base) => ({
              ...base,
              width: '150px',
            }),
            valueContainer:(base) => ({
              ...base,
              // padding:'15px 0',
              width: customWidth,
              display:'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }),
            dropdownIndicator:(base) => ({
              ...base,
              padding:'0',
              display:'flex',
              alignItems: 'center',
              justifyContent: 'center',

            }),
            indicatorSeparator: () => ({ display: "none" }),
            indicatorsContainer: (provided, state) => ({
              ...provided,
              height: '30px',
            }),

          }}
        />
    )
}

export default SelectDropdown;
